var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConnectionQuality3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H2V9H0V6Z",
    fill: "#28994E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3H5.5V9H3.5V3Z",
    fill: "#28994E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H9V9H7V0Z",
    fill: "#28994E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnectionQuality3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/connection-quality-3.5bca7212a30f69594e6683d70459d8e6.svg";